import ApiServiceAssesments from "../apiServiceAssesments.js";

const querystring = require("querystring");
var QuestionnaireService = {
  findAll: function($data) {
    return new Promise(function(resolve, reject) {
      let $options = {};
      $options.url = "questionnaire";
      $options.method = "get";

      if ($data) {
        $options.url = "questionnaire?" + querystring.stringify($data);
        console.log($options.url, "asss");
      }
      ApiServiceAssesments.request($options)
        .then((response) => {
          console.log("test");
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  checkQuestionCount: function($data) {
    return new Promise(function(resolve, reject) {
      let $options = {};
      $options.url = "checkQuestionCount";
      $options.method = "get";

      if ($data) {
        $options.url = "checkQuestionCount?" + querystring.stringify($data);
        console.log($options.url, "asss");
      }
      ApiServiceAssesments.request($options)
        .then((response) => {
          console.log("test");
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  findCategory: function($data) {
    return new Promise(function(resolve, reject) {
      let $options = {};
      $options.url = "getCategoryId";
      $options.method = "get";

      if ($data) {
        $options.url = "getCategoryId?" + querystring.stringify($data);
        console.log($options.url, "asss");
      }
      ApiServiceAssesments.request($options)
        .then((response) => {
          console.log("test");
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  findSummary: function($data) {
    return new Promise(function(resolve, reject) {
      let $options = {};
      $options.url = "getSummary";
      $options.method = "get";

      if ($data) {
        $options.url = "getSummary?" + querystring.stringify($data);
        console.log($options.url, "asss");
      }
      ApiServiceAssesments.request($options)
        .then((response) => {
          console.log("test");
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  findList: function($data) {
    return new Promise(function(resolve, reject) {
      let $options = {};
      $options.url = "dsquestionnaire";
      $options.method = "get";

      if ($data) {
        $options.url = "dsquestionnaire?" + querystring.stringify($data);
        console.log($options.url, "asss");
      }
      ApiServiceAssesments.request($options)
        .then((response) => {
          console.log("test");
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  findOne: function($data) {
    return new Promise(function(resolve, reject) {
      let $options = {};
      $options.url = "questionnaire/" + $data.id;
      console.log($options.url);
      $options.method = "get";
      if (!$data) {
        $options.data = $data;
      }
      ApiServiceAssesments.request($options)
        .then((response) => {
          // console.log('Gpt the data');
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  findAnalyzingQues: function($data) {
    return new Promise(function(resolve, reject) {
      let $options = {};
      $options.url = "analyzingQues/" + $data.id;
      console.log($options.url);
      $options.method = "get";
      if (!$data) {
        $options.data = $data;
      }
      ApiServiceAssesments.request($options)
        .then((response) => {
          // console.log('Gpt the data');
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  findCount: function($data) {
    return new Promise(function(resolve, reject) {
      let $options = {};
      $options.url = "getCount";
      $options.method = "get";

      if ($data) {
        $options.url = "getCount?" + querystring.stringify($data);
        console.log($options.url, "asss");
      }
      ApiServiceAssesments.request($options)
        .then((response) => {
          console.log("test");
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  findQuestions: function($data) {
    return new Promise(function(resolve, reject) {
      let $options = {};
      $options.url = "getQuestion";
      $options.method = "get";

      if ($data) {
        $options.url = "getQuestion?" + querystring.stringify($data);
        console.log($options.url, "asss");
      }
      ApiServiceAssesments.request($options)
        .then((response) => {
          console.log("test");
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  update: function($data) {
    return new Promise(function(resolve, reject) {
      let $options = {};
      $options.data = $data;
      $options.url = "questionnaire/" + $data.id;
      $options.method = "post";
      console.log($options);
      ApiServiceAssesments.request($options)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  save: function($data) {
    return new Promise(function(resolve, reject) {
      var $options = {};
      $options.data = $data;
      $options.url = "questionnaire" + $data.id;
      $options.method = "post";
      console.log($options);
      ApiServiceAssesments.request($options)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  create: function($data) {
    return new Promise(function(resolve, reject) {
      var $options = {};
      $options.data = $data;
      $options.url = "questionnaire";
      $options.method = "post";
      $options.data = $data
      console.log($options);
      ApiServiceAssesments.request($options)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
export default QuestionnaireService;
